import type { TimesheetEntryResponse } from "../types";

export interface EntryStats {
  work_days: number;
  work_hours: number;
  business_trip_days: number;
  holiday_weekend_hours: number;
  overtime_hours: number;
  medical_leave_days: number;
  annual_leave_days: number;
  unpaid_leave_days: number;
  study_leave_days: number;
  other_absence_days: number;
}

export function getEntryStats(
  entry: TimesheetEntryResponse | undefined
): EntryStats {
  if (!entry) {
    return {
      work_days: 0,
      work_hours: 0,
      business_trip_days: 0,
      holiday_weekend_hours: 0,
      overtime_hours: 0,
      medical_leave_days: 0,
      annual_leave_days: 0,
      unpaid_leave_days: 0,
      study_leave_days: 0,
      other_absence_days: 0,
    };
  }
  return {
    work_days: entry.work_days,
    work_hours: entry.work_hours,
    business_trip_days: entry.business_trip_days,
    holiday_weekend_hours: 0,
    overtime_hours: entry.overtime_hours,
    medical_leave_days: entry.medical_leave_days,
    annual_leave_days: entry.annual_leave_days,
    unpaid_leave_days: entry.unpaid_leave_days,
    study_leave_days: 0,
    other_absence_days: 0,
  };
}

